import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Directive({
    selector: '[appNumeric]',
    standalone: false
})
export class NumericDirective implements OnInit {
    @Input() precision: number;
    @Input() inputController: AbstractControl;
    private _dotRegex: RegExp;
    private _commaRegex: RegExp;
    private _specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];
    private _ctrlKeys: Array<number> = [65, 67, 86, 88]; // keys A, C, V, X

    constructor(private _elementRef: ElementRef) {
    }

    ngOnInit() {
        if (this.precision === 0) {
            this._dotRegex = new RegExp('^\\d*\\d$', 'g');
            this._commaRegex = this._dotRegex;
        } else {
            this._dotRegex = new RegExp('^\\d*\\.?\\d{0,' + this.precision + '}$', 'g');
            this._commaRegex = new RegExp('^\\d*\\,?\\d{0,' + this.precision + '}$', 'g');
        }
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {

        const allowedKeys = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete'];

        // Allow navigation keys
        if (allowedKeys.includes(event.key)) {
            return;
        }

        // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
        if ((event.ctrlKey || event.metaKey) && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase())) {
            return;
        }

        // Allow Shift+Insert (Paste)
        if (event.shiftKey && event.keyCode === 45) {
            return;
        }

        // Allow only numbers and decimal separator
        if (!event.key.match(/[0-9.,]/)) {
            console.warn('Blocked Key:', event.key); // Debugging
            event.preventDefault();
        }
    }


    /**
     * TODO: Need to check the functionality
     * @param event
     */
    @HostListener('keyup', ['$event'])
    onKeyUp(event: KeyboardEvent) {
        if (this.inputController) {
            const current: string = this.inputController.value ? (this.inputController.value).toString() : '';
            if (!(current.match(this._commaRegex) || current.match(this._dotRegex))) {
                event.preventDefault();
            }
        }
    }

}
